module.exports = __webpack_public_path__ + "static/images/division-banner-bg.646714c.png";